module.exports = __webpack_public_path__ + "img/void.1bf2529b.png";